<div class="container">
  <div *ngIf="unpaidInvoice$ | async">
    <app-unpaid-invoice-banner [unpaidInvoice]="unpaidInvoice$ | async"></app-unpaid-invoice-banner>
  </div>

  <div *ngIf="showAdd; else showShop">
    <div [ngClass]="{
      'container-content-xlarge': isXLarge(),
      'container-content-large': isLarge(),
      'container-content-medium': isMedium(),
      'container-content-small': isSmall(),
      'container-content-xsmall': isXSmall()
    }">
      <div class="container-content-add">
        <button mat-raised-button (click)="create()" color="primary">
          <mat-icon>post_add</mat-icon>
          New Template
        </button>
      </div>
      <div class="container-content-grid">
        <table description="Overview of newsletter templates" mat-table [dataSource]="(viewModel$ | async)?.newsletterTemplates"
          class="mat-component-background mat-elevation-z2">
          <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

          <!-- Id Column -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>Id</th>
            <td mat-cell *matCellDef="let element">{{ element.id }}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Title</th>
            <td mat-cell *matCellDef="let element">{{ element.name }}</td>
          </ng-container>

          <!-- Created Date Column -->
          <ng-container matColumnDef="createdDate" *ngIf="!isSmall() && !isXSmall()">
            <th mat-header-cell *matHeaderCellDef>Created Date</th>
            <td mat-cell *matCellDef="let element">
              {{ element.createdDate | date : "EEEE, MMMM d, y, HH:mm" }}
            </td>
          </ng-container>

          <!-- Updated Date Column -->
          <ng-container matColumnDef="updatedDate" *ngIf="!isSmall() && !isXSmall()">
            <th mat-header-cell *matHeaderCellDef>Updated Date</th>
            <td mat-cell *matCellDef="let element">
              {{ element.updatedDate | date : "EEEE, MMMM d, y, HH:mm" }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="getDisplayedColumns()"></tr>
          <tr mat-row *matRowDef="let row; columns: getDisplayedColumns()"
            [routerLink]="['/companies', row.company.id, 'newsletters', 'templates', row.id]"></tr>
        </table>
        <div class="container-paginator">
          <mat-paginator [length]="(viewModel$ | async)?.totalElements" [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions" (page)="onPageEvent($event)" [hidePageSize]="true"
            class="mat-component-background mat-elevation-z2">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #showShop>
  <app-buy-subscription-plan-banner></app-buy-subscription-plan-banner>
</ng-template>